import React from "react";
import "../WorkLoade_File_Import/loader.css";

const LoaderComponent = (value) => {
  //   const [showLoader, setShowLoader] = useState(true);

  //   useEffect(() => {
  //     const timer = setTimeout(() => {
  //       setShowLoader(false);
  //     }, 3000);

  //     return () => clearTimeout(timer);
  //   }, []);

  return (
    <div className={`loader-container ${value ? "" : "hidden"}`}>
      <div className="loader">
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
      </div>
    </div>
  );
};

export default LoaderComponent;
